import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../common/services/cqs/IPrimaryKey";

export class UpdateArbetsorderExternCommand extends BasicCommand<UpdateArbetsorderExternCommand> {
    get primaryKey(): IPrimaryKey<UpdateArbetsorderExternCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateArbetsorderExternCommand";
    constructor(init: (instance: UpdateArbetsorderExternCommand) => void) {
        super(UpdateArbetsorderExternCommand.$type, UpdateArbetsorderExternCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
